import React, { useCallback } from 'react';
import GoogleMapComponent from 'google-map-react';
import './GoogleMap.css';

export interface IPosition {
  lat: number;
  lng: number;
}

export interface IGoogleMapProps {
  position: IPosition;
  containerStyle?: any;
  defaultZoom?: number;
  onMapUpdate?: (location: any) => void;
  options?: GoogleMapComponent.MapOptions;
  staticMarker?: boolean;
}

const googleMapsApiKey = window?.location?.origin?.includes('urbansportsclub')
  ? 'AIzaSyD4Ai9gu-XoNsMNRKQfMWjxT2M3wSfwphE' // Urban Sports Club domain
  : 'AIzaSyCvQZt74Z31yiYbAFyXGP23AtmWq4oyAcM'; // Fitogram domain

export const GoogleMap = ({
  position,
  containerStyle = {},
  defaultZoom = 15,
  onMapUpdate,
  options,
  staticMarker,
}: IGoogleMapProps) => {
  const onMapLoaded = useCallback(
    ({ map, maps }: any) => {
      const marker = new maps.Marker({
        position,
        map,
        draggable: !staticMarker,
      });
      onMapUpdate &&
        marker.addListener('dragend', () => {
          onMapUpdate({
            latitude: marker.getPosition().lat(),
            longitude: marker.getPosition().lng(),
          });
        });
    },
    [position],
  );

  return (
    <div style={containerStyle}>
      <GoogleMapComponent
        key={`${position.lat}${position.lng}`}
        center={position}
        defaultCenter={position}
        defaultZoom={defaultZoom}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={onMapLoaded}
        options={options}
        bootstrapURLKeys={{ key: googleMapsApiKey }}
      />
    </div>
  );
};
